import { combineReducers } from 'redux';
import user from './userReducer';
import setting from './settingReducer';
import massages from './massagesReducer';
import complains from './complainsReducer';
import footer from './footerReducer';



export default combineReducers({
    user,
    setting,
    massages,
    complains,
    footer
});

